import L from 'leaflet';
import { MapViewState } from 'src/enums/map.enum';

export class MapController {
  map: L.Map;

  mapViewState: MapViewState;

  constructor(map: L.Map, mapViewState: MapViewState) {
    this.map = map;
    this.mapViewState = mapViewState;
  }
}
